// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__okYMa","main":"Layout_main__iXB7X","web_layout":"Layout_web_layout__L0gc-"};